import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'light'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <header className="mx-auto max-w-3xl text-center" data-id="element-60" data-mp="3k06x1v86utys">
      <span className={`inline-block rounded-full px-3 py-1 text-[10px] font-black uppercase tracking-[0.18em] sm:text-xs ${isDark ? 'bg-white/10 text-clinic-200' : 'bg-navy-800 text-white'}`} data-id="element-61" data-mp="3k0p0bbt9q8g7">
        {eyebrow}
      </span>
      <h2 className={`mt-4 text-balance text-2xl font-black leading-[1.15] tracking-tight sm:text-3xl md:text-4xl ${isDark ? 'text-white' : 'text-navy-900'}`} data-id="element-62" data-mp="1v3mhuzgdpqz">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-pretty text-base leading-relaxed sm:text-lg ${isDark ? 'text-navy-100' : 'text-navy-600'}`} data-id="element-63" data-mp="uhoaqmkmtlqb">
          {subtitle}
        </p>}
    </header>;
}